<template>
    <div class="c-avatar" style="background-color: #163845;">
      <strong style="font-size: 120%; color: white;">{{ label }}</strong>
    </div>
</template>

<script>
export default {
  name: 'Avatar',
  props: {
    label: String
  }
}
</script>
